import styled from 'styled-components';
import { Base } from 'styled';
import { Props } from './index';

type LabelProps = Pick<Props, 'textColor'>;
type LinkProps = Pick<Props, 'textColor'> & {
  isActive: boolean;
};
type ArrowProps = Pick<Props, 'textColor'>;

export const ListItem = styled(Base)``;

export const Label = styled(Base)<LabelProps>`
  white-space: nowrap;
  ${({ theme }) => theme.transitions['transition']};
  ${({ theme, textColor }) =>
    theme.hoverStyles.linkBorderBottomHidden(textColor)};
`;

export const StyledLink = styled(Base)<LinkProps>`
  white-space: nowrap;
  ${({ theme }) => theme.typography.variants.primary.xs};
  color: ${({ theme, textColor }) => theme.colors[textColor]};
  font-weight: ${({ theme, isActive }) =>
    isActive ? theme.typography.weight.bold : 'initial'};

  :hover {
    ${Label} {
      ${({ theme, textColor }) =>
        theme.hoverStyles.linkBorderBottom(textColor)};
    }
  }
`;

export const Arrow = styled(Base)<ArrowProps>`
  ${({ theme }) => theme.typography.variants.primary.xs};
  color: ${({ theme, textColor }) => theme.colors[textColor]};
`;
